import * as types from '../types/offers';

const initialState = {
    offer: {},
    refetchOffers: false,
};

function offersReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_OFFERS:
            return {
                ...state,
                offer: action.payload,
            };
        case types.REFETCH_OFFERS:
            return {
                ...state,
                refetchOffers: !state.refetchOffers,
            };

        default:
            return state;
    }
}
export default offersReducer;
